import { render } from "./updateinvoiceTheme.vue?vue&type=template&id=59b859be&scoped=true"
import script from "./updateinvoiceTheme.vue?vue&type=script&lang=js"
export * from "./updateinvoiceTheme.vue?vue&type=script&lang=js"

import "./updateinvoiceTheme.vue?vue&type=style&index=0&id=59b859be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b859be"]])

export default __exports__